module.exports = __webpack_public_path__ + "assets/img/icon-4.2c76d1d0.png";